import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FontawesomeService {

  constructor(private http: HttpClient, ) { }

  getAllIcons(): Observable<any>{
    return this.http.get('/assets/fontawesome.json')
                    .pipe(
                      map(res => res['icons'])
                    )
  }

  search(term): Observable<any>{
    return this.http.get('/assets/fontawesome.json')
                    .pipe(
                      map(res => res['icons'].filter(evt => evt.toLowerCase().includes(term)))
                    )
  }
}
